import styled from 'styled-components';

const StyledEmpty = styled.div`
  padding: 0.5rem 0;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 13px;
  font-weight: 300;
`;

const StyledError = styled.div`
  color: ${({ theme }) => theme.colors.dangerText};
  font-size: 13px;
`;

const StyledLoading = styled.div`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 13px;
  font-weight: 300;
`;

const StyledStepIdInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  font-weight: 700;
  font-size: 15px;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  padding: 0 0 2px;
  margin-bottom: 0.25rem;
  background: transparent;
  outline: none;
  cursor: text;

  &:focus {
    border-bottom-color: ${({ theme }) => theme.colors.primary};
  }
`;

const StyledActionLine = styled.p`
  margin: 0 0 1.25rem;
  font-size: ${({ theme }) => theme.fontSizes.md};
`;

const StyledActionDisplay = styled.strong`
  font-weight: 700;
`;

const StyledActionId = styled.span`
  margin-left: 0.375rem;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

const StyledSection = styled.section`
  margin-bottom: 1.25rem;
`;

const StyledSectionLabel = styled.h4`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0 0 0.625rem;
`;

export default {
  StyledEmpty,
  StyledError,
  StyledLoading,
  StyledStepIdInput,
  StyledActionLine,
  StyledActionDisplay,
  StyledActionId,
  StyledSection,
  StyledSectionLabel,
};
